import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ProtectedRoute from '../components/protected/Protected';
import { RoutesConfig } from "./RoutesConfig"
import fallbackImg from "../assets/cctv.png"

const RouteRenderer = () => {
  return (
    <div className="App"> 
      <Suspense fallback={<img src={fallbackImg} className='fallbackimage' alt=""/>}>
        <BrowserRouter>
          <Routes>
            {RoutesConfig.map((item, index) => (
              item.protected ?
                <Route element={<item.LayOut />}   key={item.path || index}>
                  {item.RoutesNames.map((res, ind) => (
                    <Route element={<ProtectedRoute />} key={ind}>
                      <Route path={res.path} element={<res.element />} />
                    </Route>
                  ))}
                </Route>
                :
                <Route element={<item.LayOut />} key={index} >
                  {item.RoutesNames.map((res, index) => (
                    <React.Fragment key={index}>
                      <Route path={res.path} key={index} element={<res.element />} />
                    </React.Fragment>
                  ))}
                </Route>
            ))}
          </Routes>
        </BrowserRouter>
      </Suspense>
    </div>
  );
}

export default RouteRenderer;
